import styled from 'styled-components';
import { bottomBarColor } from '../../Page/styles';
import { BaseStyledComponentProps, navBarButtonWrapperStyle, navBarIconStyle } from '../../../utils/styles-constants';

interface StyledShareButtonProps extends BaseStyledComponentProps {
	isInBottomBar: boolean;
}

const StyledShareButton = styled('div')`
	cursor: pointer;

	${(p: StyledShareButtonProps) => p.isInBottomBar
		? `
			display: flex;
			align-items: center;
			padding: 15px;
		`
		: `
			${navBarButtonWrapperStyle}
			height: 30px;
			width: 30px;
		`
	}

	& > svg {
		${(p: StyledShareButtonProps) => p.isInBottomBar
			? `
				flex: 0 0 auto;
				fill: ${bottomBarColor};
				height: 20px;
				width: 20px;
			`
			: `
				${navBarIconStyle}
				display: inline-block;
				fill: ${ p.theme.primary.iconsColor };
			`
		}
	}
`;

const ShareButtonLabel = styled('div')`
	font-size: 13px;
	color: ${bottomBarColor};
	margin-left: 10px;
`;

export { StyledShareButton, ShareButtonLabel };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/ShareButton/styles.ts